var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang
    ? _c(
        "div",
        { staticClass: "estates-list-heading" },
        [
          _c("div", { staticClass: "estates-count" }, [
            _c(
              "h2",
              [
                _c("img", {
                  staticClass: "geo ",
                  attrs: {
                    alt: "pin-agency",
                    src: "/img/icons/" + _vm.$root.network + "/pin-agency.svg",
                    width: "13",
                    height: "18"
                  }
                }),
                _vm._v(" "),
                _vm.ssr
                  ? _vm._t("estates-count")
                  : [
                      _c("strong", [_vm._v(_vm._s(_vm.count))]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.lang.labels[_vm.section]) +
                          "\n            "
                      ),
                      _vm.hidden_count > 0
                        ? [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.lang.labels.of_which) +
                                " "
                            ),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.hidden_count) + " ")
                            ]),
                            _vm._v(
                              _vm._s(
                                _vm.hidden_count == 1
                                  ? _vm.lang.labels.single_hidden
                                  : _vm.lang.labels.multi_hidden
                              ) + "\n            "
                            )
                          ]
                        : _vm._e()
                    ]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.fallback_filters
            ? _c(
                "div",
                { staticClass: "estates-list-fallback" },
                [
                  _c("p", { staticClass: "img" }, [
                    _c("img", {
                      attrs: {
                        alt: "fallback",
                        src:
                          "/img/icons/" +
                          _vm.$root.network +
                          "/list-fallback.svg"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")(_vm.lang.labels.fallback))
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.fallback_filters, function(filter, index) {
                    return _c("span", { key: index, staticClass: "badge" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("capitalize")(filter.title)) +
                          "\n        "
                      )
                    ])
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.ssr && _vm.count <= 0
            ? _c("div", { staticClass: "estates-list-noresults" }, [
                _c("img", {
                  staticClass: "no-results",
                  attrs: { src: "/img/icons/no-results.svg", alt: "no results" }
                }),
                _vm._v(" "),
                _c("h4", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.lang.heading.no_estates_found))
                ]),
                _vm._v(" "),
                _vm.section == "estate"
                  ? _c("div", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.lang.heading.no_estates_found_alert)
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-network mail-alert",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.openSaveSearchModal.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        },
                        [
                          _c("masked-image", {
                            attrs: { src: "/img/icons/email.svg" }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.lang.heading.save_search))
                          ])
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          ["estate", "construction"].includes(_vm.section)
            ? _c("div", { staticClass: "estates-actions" }, [
                _c(
                  "div",
                  {
                    staticClass: "estates-filters-toggle",
                    on: { click: _vm.toggleFilters }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/img/icons/filters.svg",
                        alt: _vm.lang.heading.labels.filter,
                        width: "16",
                        height: "16"
                      }
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.lang.heading.labels.filter) +
                        "\n            "
                    ),
                    _vm.primaryFiltersLength
                      ? _c(
                          "div",
                          {
                            staticClass: "badge",
                            class: "badge-" + _vm.$root.network
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.primaryFiltersLength) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: "/img/icons/" + _vm.$root.network + "/search.svg",
                        alt: "Cerca",
                        width: "16",
                        height: "16"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.sort_visible && _vm.section == "estate"
                  ? _c(
                      "div",
                      {
                        staticClass: "estates-sort",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.$refs.sort_filters.activate()
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "ordina",
                          attrs: {
                            src: "/img/icons/sort.svg",
                            alt: _vm.lang.heading.labels.sort,
                            width: "16",
                            height: "12"
                          }
                        }),
                        _vm._v(" "),
                        _c("my-multiselect", {
                          ref: "sort_filters",
                          attrs: {
                            options: _vm.config.sort_filters,
                            label: "key",
                            clearable: "",
                            placeholder: _vm.lang.heading.labels.sort,
                            "track-by": "value",
                            "custom-label": _vm.customLabel
                          },
                          on: { input: _vm.updatedSort },
                          model: {
                            value: _vm.search.sort,
                            callback: function($$v) {
                              _vm.$set(_vm.search, "sort", $$v)
                            },
                            expression: "search.sort"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "keep-alive",
            [
              this.$root.is_mobile
                ? _c(
                    "modal",
                    {
                      ref: "estates_search_filters",
                      attrs: {
                        name: "estates_search_filters",
                        title: _vm.lang.heading.modal_title,
                        "extra-class":
                          "full-screen-modal estates-search-filters-modal"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "body" },
                        [
                          _c("estates-search-filters", {
                            attrs: {
                              config: _vm.config,
                              config_map: _vm.config_map,
                              "search-data": _vm.search,
                              geo_data: _vm.geo_data,
                              "available-filters": _vm.available_filters,
                              section: _vm.section,
                              types_list: _vm.types_list
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }